<script>
import gtm from '@/core/enhanced-ecommerce-gtm'

export default {
  props: {
    productCode: {
      type: String,
      default: null
    },
    variantCode: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    brand: {
      type: String,
      default: null
    },
    price: {
      type: [Number, String],
      default: null
    }
  },
  mounted() {
    const { productCode, variantCode, name, brand, price } = this

    // item_id is the article number, the same identifier add_to_cart and purchase use. It used to
    // be the product code, which meant view_item never joined the other events in GA4 and every
    // article showed zero views however often it was bought (OC-2084). The parent product page has
    // no article, so there it falls back to the product code.
    const item = {
      item_id: variantCode || productCode
    }

    if (name) item.item_name = name
    if (brand) item.item_brand = brand

    const parsedPrice = parseFloat(price)
    if (!isNaN(parsedPrice)) item.price = parsedPrice

    // The same article group and model that add to cart sends, so a product view can be analysed
    // per article group and model too (OC-2088).
    const { analyticsCategory, analyticsVehicle } = this.$store.getters.clientModel || {}
    if (analyticsCategory) item.item_category = analyticsCategory
    if (analyticsVehicle) item.vehicle_model = analyticsVehicle

    gtm.addViewItem({ items: [item] })
  },
  render: function() {
    return ''
  }
}
</script>
